import React, { Component } from 'react';
import moment  from 'moment';
import { BarGraph } from '../../../common/graph/bar-graph.component'
import './monthly-spend.component.css';
import { ChartHeaderDropdown } from '../../../common/data-header/chart-header-dropdown.component';
import { CHARGE_TYPE_CATEGORIES as categories } from '../../../../utils/constant.utils';
import Translation from '../../../common/translation/translation.component';

const barData = [{ name: categories.Voice.type, color: categories.Voice.spendDetailsColor },
    { name: categories.Messaging.type, color: categories.Messaging.spendDetailsColor },
    { name: categories.Data.type, color: categories.Data.spendDetailsColor },
    { name: categories.Other.type, color: categories.Other.spendDetailsColor }]

var date = new Date()
var currMonth = moment.utc(date).format("MMM");

class PersonalPage extends Component {
    constructor(props) {
        super();
        this.state = ({
            spendMonth : [], 
            selectVal: ""
        })
    }
    handleChange = (e) => {
        this.setState({ 
            selectVal: e.target.value
        });
    }
    render() {
        const { spendChart, usageSpendBarData, currencySymbol, usageSpendCurrMonthTotal } = this.props;
        return (
            <div className="monthly-spend-container">
                <div className="monthly-spend-header">                   
                    <ChartHeaderDropdown
                        haveOneIcone={false}
                        haveIconInfo={false}
                        iconInfo="info-circle-solid"
                        haveLedger={false} ledger={barData}
                        spendHeaderName={<Translation translationKey="monthlySpend" />}
                        circleIcon={false}
                        circleFirstIcon="list-regular"
                        circleSecondIcon="th-solid"
                        oneIcon="vertical-grid"
                        haveInput={false}
                        haveDropdown={false}
                        isMonthlySpendTitle={true}
                    />
                </div>
                <div className="monthly-spend">
                    <div className="graph-container">
                        <BarGraph data={usageSpendBarData} barData={barData} graphFooter={spendChart} currencySymbol={currencySymbol} />
                    </div>
                    <div className="total-spend-cont"> 
                        <span className="total-spend">{<Translation translationKey="totalSpendFor" />}</span>
                        <span className="currMonth-val"> {currMonth} </span>
                        <span className="total-spend-amount"> {currencySymbol + ' ' + usageSpendCurrMonthTotal.toLocaleString(navigator.language, { minimumFractionDigits: 2 })} </span>
                    </div>
                </div>
            </div>
        )
    }
}

export default PersonalPage;